import { makeStyles } from '@bayon/commons';

export const useStyles = makeStyles({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  router: {
    height: '100%',
    width: '100%',
  },
});
